//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Cookies } from '@/scripts/libs/cookies'
import wcs from '@/scripts/libs/wcs'
import { createNamespacedHelpers } from 'vuex'
import { COUNTRY_OVERLAY_FLAG, PUSH_NOTIFICATION_SEEN, AKA_CC } from '@/scripts/constants/cookies'
import { EVENTS } from '@/scripts/constants/css-classes'
import { TRACKER_CLICK } from '@/scripts/constants/tracker'
import { TABLET, MOBILE } from '@/scripts/constants/media-query'
import NewsletterModal from '@/scripts/libs/newsletter-modal'
import StickyBarTooltip from '@/scripts/libs/sticky-bar-tooltip'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'
import { ZERO_EXPIRE_VALUE } from '@/scripts/constants/cookies'

const { mapGetters: mapGettersPdp } = createNamespacedHelpers('pdp')
const { pushNotification, locale } = wcs.getStoreConfig()
const pushNotificationCookie = Cookies.get(PUSH_NOTIFICATION_SEEN)
const clicksInStorage = 'push_notification_clicks'

export default {
  name: 'rb-push-notification-popup',

  props: {
    color: {
      type: String,
      default: 'dark',
    },
    link: {
      type: String,
      default: '/',
    },
  },

  data: function () {
    return {
      clicks: 0,
      currentScroll: 0,
      openingPositionOnFirstTime: 0,
      range: 400,
      isOpen: false,
      avoidClosure: false,
    }
  },

  computed: {
    ...mapGettersPdp([
      'minicartIsVisible',
      'productIsLoading',
      'selectedProduct',
      'isRoxPanelRendered',
    ]),
    navigateToLoginPage() {
      const headerLoginUrl = wcs.getEndPoint('headerLoginUrl')
      return headerLoginUrl
    },

    isDark() {
      return this.color !== 'dark'
    },

    closeIconClass() {
      return !this.isDark ? 'common__icon--close-bold-light' : 'common__icon--close-bold'
    },

    isMobileOrTablet() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
  },

  watch: {
    currentScroll(current, previous) {
      if (!this.minicartIsVisible) {
        this.handleDisplay(current, previous)
      }
    },
    minicartIsVisible(val) {
      if (val) {
        this.isOpen = false
      }
    },
    selectedProduct() {
      if (StickyBarTooltip.isEnabled() && this.isOpen) {
        this.isOpen = false
      }
    },
    productIsLoading(val) {
      if (!val) {
        this.avoidClosure = true
      }
    },
    isRoxPanelRendered(val) {
      if (val) {
        this.isOpen = false
      }
    },
  },

  created: function () {
    if (pushNotificationCookie === 'true') {
      return
    }

    this.clicks = localStorage.getItem(clicksInStorage) ?? 0
    if (this.clicks < pushNotification.clicksNumberToOpening) {
      window.addEventListener(EVENTS.CLICK, this.onPageClick)
    }
  },

  beforeDestroy() {
    window.removeEventListener(EVENTS.SCROLL, this.slideAnimation)
    window.removeEventListener(EVENTS.CLICK, this.onPageClick)
    window.removeEventListener(EVENTS.SCROLL, this.updateCurrentScroll)
  },

  methods: {
    onCloseClick() {
      this.isOpen = false
      Cookies.set(PUSH_NOTIFICATION_SEEN, true, ZERO_EXPIRE_VALUE)
      window.removeEventListener(EVENTS.SCROLL, this.slideAnimation)
      window.removeEventListener(EVENTS.SCROLL, this.updateCurrentScroll)
    },

    onPageClick() {
      this.clicks++
      localStorage.setItem(clicksInStorage, this.clicks)

      const canShowNotification =
        this.clicks >= pushNotification.clicksNumberToOpening &&
        this.otherOverlaysAreHidden() &&
        !this.isRoxPanelRendered
      if (canShowNotification) {
        this.openingPositionOnFirstTime = window.scrollY
        this.isOpen = true

        window.addEventListener(EVENTS.SCROLL, this.slideAnimation)
        window.removeEventListener(EVENTS.CLICK, this.onPageClick)
      }
    },

    otherOverlaysAreHidden() {
      const mincartIsHidden = !this.minicartIsVisible
      const countryOverlayIsHidden = this.countryOverlayIsEnabled()
        ? Cookies.get(COUNTRY_OVERLAY_FLAG) === 'true'
        : true
      const newsletterModalIsHidden = NewsletterModal.isHidden(this.isMobileOrTablet)
      const stickyBarTooltipIsHidden = wcs.isInPdp() ? StickyBarTooltip.isHidden() : true

      return (
        countryOverlayIsHidden &&
        newsletterModalIsHidden &&
        stickyBarTooltipIsHidden &&
        mincartIsHidden
      )
    },

    countryOverlayIsEnabled() {
      const actualCountryFromAkamai = Cookies.get(AKA_CC)
      const countryCode = WcsLocales.mapCountryCode(locale)
      return actualCountryFromAkamai !== countryCode
    },

    redirect() {
      this.$ma.trackEvent({
        event: TRACKER_CLICK,
        value: {
          data_element_id: 'X_All_Notif',
        },
      })
      Cookies.set(PUSH_NOTIFICATION_SEEN, true)
      window.open(this.link, '_self')
    },

    slideAnimation() {
      if (this.avoidClosure) {
        this.avoidClosure = false
        return
      }

      if (this.scrollIsBeyondLimit()) {
        this.isOpen = false
        window.removeEventListener(EVENTS.SCROLL, this.slideAnimation)
        window.addEventListener(EVENTS.SCROLL, this.updateCurrentScroll)
      }
    },

    scrollIsBeyondLimit() {
      const currentPosition = window.scrollY

      const underRange = currentPosition > this.openingPositionOnFirstTime + this.range
      const overRange = currentPosition < this.openingPositionOnFirstTime - this.range

      return underRange || overRange
    },

    handleDisplay(currentScroll, previousScroll) {
      const isScrollingDown = previousScroll < currentScroll
      if (this.isOpen && isScrollingDown) {
        this.isOpen = false
        return
      }

      if (!this.isOpen && !isScrollingDown) {
        this.isOpen = true
      }
    },

    updateCurrentScroll() {
      this.currentScroll = window.scrollY
    },
  },
}
